export function getObjectType(objectType) {
    return bacnetObjectTypeConversion[objectType] || 'Proprietary Object';
}

const bacnetObjectTypeConversion = {
    0:  'Analog Input',
    1:  'Analog Output',
    2:  'Analog Value',
    3:  'Binary Input',
    4:  'Binary Output',
    5:  'Binary Value',
    6:  'Calendar',
    7:  'Command',
    8:  'Device',
    9:  'Event Enrollment',
    10: 'File',
    11: 'Group',
    12: 'Loop',
    13: 'Multi-State Input',
    14: 'Multi-State Output',
    15: 'Notification Class',
    16: 'Program',
    17: 'Schedule',
    18: 'Averaging',
    19: 'Multi-State Value',
    20: 'Trend Log',
    21: 'Life Safety Point',
    22: 'Life Safety Zone',
    23: 'Accumulator',
    24: 'Pulse Converter',
    25: 'Event Log',
    26: 'Global Group',
    27: 'Trend Log Multiple',
    28: 'Load Control',
    29: 'Structured View',
    30: 'Access Door',
    31: 'Timer',
    32: 'Access Credential',
    33: 'Access Point',
    34: 'Access Rights',
    35: 'Access User',
    36: 'Access Zone',
    37: 'Credential Data Input',
    38: 'Network Security',
    39: 'Bit String Value',
    40: 'Character String Value',
    41: 'Date Pattern Value',
    42: 'Date Value',
    43: 'Date Time Pattern Value',
    44: 'Date Time Value',
    45: 'Integer Value',
    46: 'Large Analog Value',
    47: 'Octet String Value',
    48: 'Positive Integer Value',
    49: 'Time Pattern Value',
    50: 'Time Value',
    51: 'Notification Forwarder',
    52: 'Alert Enrollment',
    53: 'Channel',
    54: 'Lighting Output',
    55: 'Binary Lighting Output',
    56: 'Network Port',
    57: 'Elevator Group',
    58: 'Escalator',
    59: 'Lift'
};
